import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "hooks/Auth";
import { setPublicationUuid, setPublicationCode } from "helpers/Auth";

export default function ChooserShell(props) {
    const auth = useAuth();
    const [filter, setFilter] = useState("");
    const searchRef = useRef();

    const setLicense = (license) => {
        setPublicationUuid(license.uuid);
        setPublicationCode(license.code);
        window.location.reload();
    };

    const filterCallback = (license) => {
        if (filter === "") {
            return true;
        }

        return license.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
    };

    useEffect(() => {
        searchRef.current.focus();
    }, []);

    return (
        <div className="flex flex-col justify-center pt-12 pb-4 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <img
                    className="mx-auto h-12 w-auto"
                    src="https://static.getsnworks.com/placeholder/assets/img/logo.svg"
                    alt="SNworks"
                />
                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                    Please select a publication
                </h2>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                        <div className="mx-auto max-w-3xl text-center">
                            <input
                                ref={searchRef}
                                type="text"
                                placeholder="Filter by name..."
                                onKeyUp={(e) => setFilter(e.target.value)}
                                className="block w-full rounded-md border-gray-300 py-2 px-4 shadow-sm focus:border-green-500 focus:ring-green-500 disabled:bg-white sm:text-sm"
                            />
                            <ul className="cursor-pointer divide-y divide-gray-200">
                                {auth.user.licenses
                                    .filter(filterCallback)
                                    .map((license) => (
                                        <li
                                            key={license.uuid}
                                            className="py-4"
                                            onClick={() => setLicense(license)}
                                        >
                                            <p className=" text-gray-900">
                                                {license.name}
                                            </p>
                                            <p className="text-xs text-gray-400">
                                                {license.uri}
                                            </p>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
